import type { SelectableFixture } from "@slot/game-shell";
import { bigWin } from "./fixtures/base/big_win";
import { mergeChain } from "./fixtures/base/merge_chain";
import { mergeDouble } from "./fixtures/base/merge_double";
import { mergeH1Scatter } from "./fixtures/base/merge_h1_scatter";
import { mergeLeftover } from "./fixtures/base/merge_leftover";
import { mergeSingle } from "./fixtures/base/merge_single";
import { noWin } from "./fixtures/base/no_win";
import { noWin2 } from "./fixtures/base/no_win_2";
import { noWin3 } from "./fixtures/base/no_win_3";
import { secretBonus } from "./fixtures/base/secret_bonus";
import { fsBonusBuy } from "./fixtures/feature/fs_bonus_buy";
import { fsMergeTrigger } from "./fixtures/feature/fs_merge_trigger";
import { fsSecretBonus } from "./fixtures/feature/fs_secret_bonus";

/**
 * The rounds the dev tools select by id: the hook's `loadFixture(id)` (the e2e suite), the dev menu's playlist,
 * `?fixtures=`. Ids mirror the fixture file names; the order and the groups are the dev menu's.
 */
export const SELECTABLE_FIXTURES: readonly SelectableFixture[] = [
  { id: "no_win", label: "No win", group: "Base", create: noWin },
  { id: "no_win_2", label: "No win (three L2)", group: "Base", create: noWin2 },
  { id: "no_win_3", label: "No win (two FS)", group: "Base", create: noWin3 },
  { id: "merge_single", label: "One merge (L1 → L2)", group: "Merges", create: mergeSingle },
  { id: "merge_leftover", label: "A leftover cell (L3 ×5)", group: "Merges", create: mergeLeftover },
  { id: "merge_double", label: "Two clusters at once", group: "Merges", create: mergeDouble },
  { id: "merge_chain", label: "Up the ladder to FS, 5 merges", group: "Merges", create: mergeChain },
  { id: "merge_h1_scatter", label: "Cap of 4, then H1 → FS", group: "Merges", create: mergeH1Scatter },
  { id: "big_win", label: "Huge win (44.2×)", group: "Big wins", create: bigWin },
  { id: "fs_merge_trigger", label: "Merges make the trigger, free spins", group: "Flows", create: fsMergeTrigger },
  { id: "fs_bonus_buy", label: "Bought free spins", group: "Flows", create: fsBonusBuy },
  { id: "secret_bonus", label: "Secret Bonus lands (tap it)", group: "Flows", create: secretBonus },
  { id: "fs_secret_bonus", label: "Secret Bonus bought (12 spins)", group: "Flows", create: fsSecretBonus },
];
